(function () {
  // Title of the collection whose products are allowed for local delivery.
  var ALLOWED_COLLECTION = 'Eldora Local Delivery';

  // Widget fee lines (pickup / delivery products) must not count against the rule.
  function isWidgetFeeItem(item) {
    if (item.name === 'Pickup Instore') return true;
    var variantId = String(item.id);
    if (typeof pickupProduct !== 'undefined' && String(pickupProduct) === variantId) return true;
    if (typeof deliveryProduct !== 'undefined' && String(deliveryProduct) === variantId) return true;
    return false;
  }

  // True when every real cart item belongs to the allowed collection.
  function cartAllowsDelivery() {
    if (typeof crItems === 'undefined' || !crItems.length) return true;

    var onlyAllowedProducts = true;

    for (var i = 0; i < crItems.length; i++) {
      var itemCollections = crItems[i].collections || '';
      var itemTitle = crItems[i].name || '';
      if (isWidgetFeeItem(crItems[i])) continue;
      //console.log({itemTitle})
      console.log('-->', itemCollections);

      if (itemCollections.toLowerCase().indexOf(ALLOWED_COLLECTION.toLowerCase()) === -1) {
        onlyAllowedProducts = false;
      }
    }

    return onlyAllowedProducts;
  }

  function toggleDeliveryOption() {
    if (typeof jqCR === 'undefined') return;

    var $delivery = jqCR('.cr-delivery-button');
    if (!$delivery.length) return;

    if (cartAllowsDelivery()) {
      $delivery.show();
      return;
    }

    // Cart has products outside the collection: hide delivery.
    // If delivery is currently selected, fall back to shipping (or pickup).
    if ($delivery.hasClass('selected')) {
      var $shipping = jqCR('.cr-shipping-method');
      if ($shipping.length && !$shipping.hasClass('cr-hide')) {
        $shipping.trigger('click');
      } else {
        jqCR('.js-toggle-pickup').trigger('click');
      }
    }
    $delivery.hide();
  }

  // Widget buttons are in the DOM → apply the rule.
  document.addEventListener('crButtonsLoaded', toggleDeliveryOption);
})();
